<template>
  <div>
    
    <span v-if="language == 'czech'">
      <privacy-czech/>
    </span>
    <span v-else-if="language == 'bulgarian'">
      <privacy-bulgarian/>
    </span>
    <span v-else-if="language == 'norwegian'">
      <privacy-norwegian/>
    </span>
    <span v-else-if="language == 'slovakia'">
      <privacy-slovakia/>
    </span>
    <span v-else-if="lang_a4all == 'swedish'">
        <privacy-swedish/>
    </span>
    <span v-else-if="lang_a4all == 'finnish'">
      <privacy-finnish/>
    </span>
    <span v-else-if="lang_a4all == 'romanian'">
      <privacy-romanian/>
    </span>
    <span v-else>
      <privacy-english/>
    </span>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from './PrivacyPolicyEnglish';
import PrivacyPolicyCzech from './PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import PrivacyPolicySlovakian from './PrivacyPolicySlovakia';
import PrivacyPolicySwedish from './../PrivacyPolicySwedish';
import PrivacyPolicyFinnish from './../PrivacyPolicyFinnish';
import PrivacyPolicyRomanian from './../PrivacyPolicyRomanian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["language"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian,
    'privacy-slovakia': PrivacyPolicySlovakian,
    'privacy-swedish': PrivacyPolicySwedish,
    'privacy-romanian': PrivacyPolicyRomanian,
    'privacy-finnish': PrivacyPolicyFinnish
    
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/PrivacyPolicy.vue